import React, {Component} from "react";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {LocalStorage} from "../../utils/LocalStorage";
import {LoginWithGoogle} from "./LoginWithGoogle";
import {Navigate} from "react-router-dom";
import { withTranslation } from "react-i18next";

class LoginButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoggedIn: false,
            firstTime: null,
            invitationPendingHash: null
        };

        this.handleGoogleLoginSuccessful = this.handleGoogleLoginSuccessful.bind(this);
    }

    handleGoogleLoginSuccessful(accountData) {
        new APIClient(API_URL + 'login/').call('POST', accountData)
            .then((responseData) => {
                if (responseData.status === 'ERROR') {
                    alert(responseData['error_message']);
                } else if (responseData.status === 'OK') {
                    this.handleLoginSuccessful(responseData);
                }
            });
    }

    handleLoginSuccessful(responseData) {
        const userData = responseData.logged_user_data;

        if (userData) {
            LocalStorage.saveUserData(userData.user_id, userData.token, userData.user_type, userData.agency_status, userData.language, userData.client_id || null, userData.is_dashbo_mcp, userData.free_trial_days_remaining, userData.agency_logo_url, userData.agency_display_name, userData.brand_primary_color, userData.brand_secondary_color);
        }

        if (responseData.first_time_logged) {
            this.setState({firstTime: true, isLoggedIn: true, invitationPendingHash: responseData.invitation_pending_hash});
        } else {
            this.setState({firstTime: false, isLoggedIn: true, invitation_pending_hash: null});
        }
    }

    _homePath() {
        return {pathname: "/"};
    }

    _getRedirectPath() {
        // Verificar si hay una URL guardada para redirigir después del login
        const redirectUrl = LocalStorage.getRedirectUrl();
        if (redirectUrl) {
            LocalStorage.clearRedirectUrl();
            // Usar la URL completa directamente (incluye pathname + query params)
            return redirectUrl;
        }
        return this._homePath();
    }

    _registrationPath() {
        return {pathname: "/agency-register"};
    }

    _acceptInvitationPath(hash) {
        return {pathname: "/accept-invitation/"+hash};
    }

    render() {
        const { t } = this.props;
        if (this.state.isLoggedIn) {
            if (this.state.firstTime) {
                if(this.state.invitationPendingHash)
                    return <Navigate to={this._acceptInvitationPath(this.state.invitationPendingHash)}/>
                return <Navigate to={this._registrationPath()}/>;
            } else {
                return <Navigate to={this._getRedirectPath()}/>;
            }
        } else {
            return (
                    <LoginWithGoogle
                        onGoogleLoginSucessful={this.handleGoogleLoginSuccessful}
                        buttonText={t('login.with_google')}
                    />
            );
        }
    }
}

export default withTranslation()(LoginButton);
